import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

  @Input() videoDetails: any;
  openIframe = false;
  constructor() { }

  ngOnInit(): void { 
    
  }

  clickOnImage() {
    this.openIframe = true
  }

  closeVideo() {
    this.openIframe = false;
    const iFrames = document.querySelectorAll('iframe');
    iFrames[0].src = this.videoDetails.videoLink
  }

}
